import React from 'react';
import Paragraph from 'structure/launchpad/components/Typography';
import { twMerge } from 'tailwind-merge';

type StakeDetailRowProps = {
  label: string;
  labelClassName?: string;
  valueClassName?: string;
  value: React.ReactNode | string;
};

export function DetailsRow({
  label,
  labelClassName,
  valueClassName,
  value,
}: StakeDetailRowProps) {
  return (
    <div className='flex flex-row items-center justify-between'>
      <Paragraph className={twMerge('text-xs	text-[#B4BCD0]', labelClassName)}>
        {label}
      </Paragraph>
      <div>
        {typeof value === 'string' || typeof value === 'number' ? (
          <Paragraph
            className={twMerge('text-sm text-[#F7F8F8]', valueClassName)}
          >
            {value}
          </Paragraph>
        ) : (
          value
        )}
      </div>
    </div>
  );
}
